import {
	shopBoardList,
	shopBoardFieldConfig,
	shopBoardGroupList,
	shopBoardGroupCreate,
	shopBoardGroupUpdate,
	shopBoardGroupDelete,
	shopBoardBatchSetGroup,
	shopBoardDetail,
	shopDataDetail,
	shopDataSummary,
	getShopList,
	productBoardList,
	productBoardFieldConfig,
	productBoardGroupList,
	productBoardGroupCreate,
	productBoardGroupUpdate,
	productBoardGroupDelete,
	productBoardBatchSetGroup,
	wechatShopDataDetail
} from "../../../api/main/shop_board.js";

let modules = {
	namespaced: true,
	state: {},
	mutations: {},
	actions: {
		getShopBoardList(context, payload){
			shopBoardList(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		saveFieldConfig(context, payload){
			shopBoardFieldConfig(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getShopBoardGroupList(context, payload){
			shopBoardGroupList(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opShopBoardGroupCreate(context, payload){
			shopBoardGroupCreate(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opShopBoardGroupUpdate(context, payload){
			shopBoardGroupUpdate(payload.id, payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opShopBoardGroupDelete(context, payload){
			shopBoardGroupDelete(payload.id).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opShopBoardBatchSetGroup(context, payload){
			shopBoardBatchSetGroup(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getShopBoardDetail(context, payload){
			shopBoardDetail(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getShopDataDetail(context, payload){
			return shopDataDetail(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			}).catch(err => {
				if (payload.error) {
					payload.error(err)
				}
			})
		},
		getShopDataSummary(context, payload){
			shopDataSummary(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getShopList(context, payload){
			getShopList(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getProductBoardList(context, payload){
			productBoardList(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		saveProductFieldConfig(context, payload){
			productBoardFieldConfig(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getProductBoardGroupList(context, payload){
			productBoardGroupList(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opProductBoardGroupCreate(context, payload){
			productBoardGroupCreate(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opProductBoardGroupUpdate(context, payload){
			productBoardGroupUpdate(payload.id, payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opProductBoardGroupDelete(context, payload){
			productBoardGroupDelete(payload.id).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		opProductBoardBatchSetGroup(context, payload){
			productBoardBatchSetGroup(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			})
		},
		getWechatShopDataDetail(context, payload){
			wechatShopDataDetail(payload.data).then(res => {
				if (payload.success) {
					payload.success(res)
				}
			}).catch(err => {
				if (payload.error) {
					payload.error(err)
				}
			})
		}
	}
}
export default modules;
